export const AccordionDT = {
	accordion: {
		css: ({ dt }) => `
              .p-accordion-clear {
                .p-accordionheader, .p-accordioncontent-content {
                  border-color: transparent;
                  background-color: ${dt('content.background')};
                  gap: ${dt('spacing.sm')};
                }
                .p-accordioncontent-content {
                  // padding-top: 0;
                }
                .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader:not(:hover) {
                    background: ${dt('content.background')};
                }
                .p-accordionpanel:not(.p-accordionpanel-active):not(.p-disabled) > .p-accordionheader:hover, .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader:hover {
                    background: ${dt('surface.50')};
                }
              }
              .p-accordion-clear-border {
                .p-accordionheader, .p-accordioncontent-content {
                  border-color: transparent;
                }
              }
              .p-accordion-gray-background {
                .p-accordionheader, .p-accordioncontent-content {
                  background-color: ${dt('surface.50')};
                }
                .p-accordioncontent-content {
                  // padding-top: 0;
                }
                .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader:not(:hover) {
                    background: ${dt('surface.50')};
                }
                .p-accordionpanel:not(.p-accordionpanel-active):not(.p-disabled) > .p-accordionheader:hover, .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader:hover {
                    background: ${dt('surface.50')};
                }
              }
        `,
	},
};
